import { render, staticRenderFns } from "./ResourceDrawer.vue?vue&type=template&id=94a2460c&scoped=true&"
import script from "./ResourceDrawer.vue?vue&type=script&lang=js&"
export * from "./ResourceDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a2460c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SectionsList: require('/opt/buildhome/repo/components/lists/SectionsList.vue').default})
